export default [
    {
        key: 'default',
        title: '默认',
        lists: [
            {
                width: 1920,
                height: 1080,
                w: 16,
                h: 9,
            },
            {
                width: 1920,
                height: 1280,
                w: 3,
                h: 2,
            },
            {
                width: 1920,
                height: 1440,
                w: 4,
                h: 3,
            },
            {
                width: 1920,
                height: 1536,
                w: 5,
                h: 4,
            },
            {
                width: 1920,
                height: 1920,
                w: 1,
                h: 1,
            },
            {
                width: 1080,
                height: 1350,
                w: 4,
                h: 5,
            },
            {
                width: 1080,
                height: 1440,
                w: 3,
                h: 4,
            },
            {
                width: 1080,
                height: 1620,
                w: 2,
                h: 3,
            },
            {
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            },
        ],
    },
    {
        key: 'wechat',
        title: '微信',
        lists: [
            {
                title: '朋友圈',
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            },
            {
                title: '公众号封面',
                width: 900,
                height: 500,
                w: 9,
                h: 5,
            },
            {
                title: '公众号配图',
                width: 900,
                height: 600,
                w: 3,
                h: 2,
            },
            {
                title: '小程序封面',
                width: 480,
                height: 270,
                w: 16,
                h: 9,
            }
        ],
    },
    {
        key: 'weibo',
        title: '微博',
        lists: [
            {
                title: '标准',
                width: 1080,
                height: 1440,
                w: 3,
                h: 4,
            },
            {
                title: '横版',
                width: 1920,
                height: 1080,
                w: 16,
                h: 9,
            },
            {
                title: '方形',
                width: 1080,
                height: 1080,
                w: 1,
                h: 1,
            },
            {
                title: '头图',
                width: 1125,
                height: 445,
                w: 5,
                h: 2,
            }
        ],
    },
    {
        key: 'douyin',
        title: '抖音',
        lists: [
            {
                title: '竖版视频',
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            },
            {
                title: '横版视频',
                width: 1920,
                height: 1080,
                w: 16,
                h: 9,
            },
            {
                title: '图文卡片',
                width: 800,
                height: 800,
                w: 1,
                h: 1,
            },
            {
                title: '商品橱窗',
                width: 750,
                height: 1000,
                w: 3,
                h: 4,
            }
        ],
    },
    {
        key: 'xiaohongshu',
        title: '小红书',
        lists: [
            {
                title: '长图',
                width: 1000,
                height: 1334,
                w: 3,
                h: 4,
            },
            {
                title: '方图',
                width: 1000,
                height: 1000,
                w: 1,
                h: 1,
            },
            {
                title: '视频',
                width: 1080,
                height: 1920,
                w: 9,
                h: 16,
            }
        ],
    },
    {
        key: 'bilibili',
        title: 'B站',
        lists: [
            {
                title: '封面',
                width: 1146,
                height: 717,
                w: 16,
                h: 10,
            },
            {
                title: '头图',
                width: 1920,
                height: 480,
                w: 4,
                h: 1,
            },
            {
                title: '文章封面',
                width: 1200,
                height: 750,
                w: 8,
                h: 5,
            }
        ],
    },
];
